jQuery(function ($) {
    let $pageTop = $(".js-page-top");
    let $footer = $(".p-footer");
    $pageTop.hide();

    $(window).on("scroll resize", function () {
        let scrollTop = $(this).scrollTop();
        let winHeight = $(this).height();
        let footerTop = $footer.offset().top;
        let windowBottom = scrollTop + winHeight;

        if (scrollTop > 40) {
            $pageTop.fadeIn();
        } else {
            $pageTop.fadeOut();
        }

        let stopMargin = 10;
        let overlap = windowBottom - footerTop + stopMargin;
        let translateY = overlap > 0 ? overlap : 0;

        $pageTop.css({
            transform: `translateY(-${translateY}px)`
        });
    });

    $pageTop.on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 500);
        return false;
    });
});